import * as Car from "../data/Car";
import * as Train from "../data/Train"
import { CampaignParticipation, TripType } from "../data/FrontendTypes";
import { useEffect, useState } from "react";
import TripList from "../components/TripList";
import DistanzRechner from "../components/DistanzRechner";
import { useDataContext } from "../data/DataContext";

export default function AllTripsPage(): React.ReactElement {

    const [btbTrips, setBtbTrips] = useState<TripType[]>([])

    const [customerTrips, setCustomerTrips] = useState<TripType[]>([])

    const { campaignParticipation, saveCampaignParticipation, campaignName } = useDataContext();

    useEffect(() => {
        if (campaignParticipation) {
            setBtbTrips(campaignParticipation.trips.filter(trip => !trip.toCustomer));
            setCustomerTrips(campaignParticipation.trips.filter(trip => trip.toCustomer));
        }
    }, [campaignParticipation]);

    const saveTrips = () => {
        if (!campaignParticipation) return;
        const updatedCampaignParticipation: CampaignParticipation = {
            ...campaignParticipation,
            trips: [...btbTrips, ...customerTrips],
        };
        saveCampaignParticipation(updatedCampaignParticipation);
    }

    if (!campaignParticipation) {
        return <div>Loading...</div>;
    }

    return (
        <div id="anfahrten-page">
            <div className="page-header">
                <h1>{campaignName}</h1>
                <p>
                    Hier kannst du deine Anfahrten zur BTB und zum Kunden verwalten. <br/>
                    Die Anfahrten werden in der Kampagne gespeichert und in die CO2-Bilanz eingerechnet.
                </p>
            </div>
            <div className="alle-anfahrten">
                <TripList
                    name={"Zur BTB"}
                    list={btbTrips}
                    setList={setBtbTrips}
                    toCustomer={false}
                    save={saveTrips}
                    />
                <TripList
                    name={"Zum Kunden"}
                    list={customerTrips}
                    setList={setCustomerTrips}
                    toCustomer={true}
                    save={saveTrips}
                    />
            </div>
            <DistanzRechner/>
        </div>
    );
}

